/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Pedal_Function_Mapping_DescInputs */

const en_options_pedal_function_mapping_desc = /** @type {(inputs: Options_Pedal_Function_Mapping_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Some foot pedal models may require the default function mappings to be updated.`)
};

const fr_options_pedal_function_mapping_desc = /** @type {(inputs: Options_Pedal_Function_Mapping_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Certains modèles de pédale peuvent nécessiter la mise à jour des affectations par défaut.`)
};

const de_options_pedal_function_mapping_desc = /** @type {(inputs: Options_Pedal_Function_Mapping_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bei einigen Fußpedalmodellen müssen möglicherweise die Standardfunktionszuordnungen aktualisiert werden.`)
};

const it_options_pedal_function_mapping_desc = /** @type {(inputs: Options_Pedal_Function_Mapping_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alcuni modelli di pedali potrebbero richiedere l'aggiornamento delle mappature delle funzioni predefinite.`)
};

const ru_options_pedal_function_mapping_desc = /** @type {(inputs: Options_Pedal_Function_Mapping_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Для некоторых моделей ножных педалей может потребоваться обновление настроек функций по умолчанию.`)
};

const es_options_pedal_function_mapping_desc = /** @type {(inputs: Options_Pedal_Function_Mapping_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es posible que algunos modelos de pedales requieran que se actualicen las asignaciones de funciones predeterminadas.`)
};

const zh_cn2_options_pedal_function_mapping_desc = /** @type {(inputs: Options_Pedal_Function_Mapping_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`某些型号的脚踏板可能需要更新默认功能映射。`)
};

const ja_options_pedal_function_mapping_desc = /** @type {(inputs: Options_Pedal_Function_Mapping_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一部のフットペダル モデルでは、デフォルトの機能マッピングを更新する必要がある場合があります。`)
};

const hi_options_pedal_function_mapping_desc = /** @type {(inputs: Options_Pedal_Function_Mapping_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कुछ फुट पेडल मॉडल के लिए डिफ़ॉल्ट फ़ंक्शन मैपिंग को अपडेट करने की आवश्यकता हो सकती है।`)
};

const pt_pt2_options_pedal_function_mapping_desc = /** @type {(inputs: Options_Pedal_Function_Mapping_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alguns modelos de pedais podem exigir que os mapeamentos de funções padrão sejam atualizados.`)
};

/**
* | output |
* | --- |
* | "Some foot pedal models may require the default function mappings to be updated." |
*
* @param {Options_Pedal_Function_Mapping_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_pedal_function_mapping_desc = /** @type {((inputs?: Options_Pedal_Function_Mapping_DescInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Pedal_Function_Mapping_DescInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_pedal_function_mapping_desc(inputs)
	if (locale === "de") return de_options_pedal_function_mapping_desc(inputs)
	if (locale === "it") return it_options_pedal_function_mapping_desc(inputs)
	if (locale === "ru") return ru_options_pedal_function_mapping_desc(inputs)
	if (locale === "es") return es_options_pedal_function_mapping_desc(inputs)
	if (locale === "zh-CN") return zh_cn2_options_pedal_function_mapping_desc(inputs)
	if (locale === "ja") return ja_options_pedal_function_mapping_desc(inputs)
	if (locale === "hi") return hi_options_pedal_function_mapping_desc(inputs)
	if (locale === "pt-PT") return pt_pt2_options_pedal_function_mapping_desc(inputs)
	return en_options_pedal_function_mapping_desc(inputs)
});